import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { LanguageModel } from "../../modules/account/models/language.model";
import { CountryModel } from "../../modules/account/models/country.model";
import { AppSettings } from "app/app.settings";
import { noResponseToastHeaders } from "@shared/constants";

@Injectable({
   providedIn: "root"
})
export class LocationService {
   private httpClient = inject(HttpClient);
   private appSettings = inject(AppSettings);

   private readonly baseUri: string;
   private readonly endpoint: string;

   constructor() {
      this.baseUri = `${this.appSettings.baseCoreApiUrl}`;
      this.endpoint = `location`;
   }

   public getLanguages(): Observable<Array<LanguageModel>> {
      return this.httpClient.get<Array<LanguageModel>>(
         `${this.baseUri}/${this.endpoint}/languages`,
         { headers: noResponseToastHeaders }
      );
   }

   public getCountries(): Observable<Array<CountryModel>> {
      return this.httpClient.get<Array<CountryModel>>(
         `${this.baseUri}/${this.endpoint}/countries`,
         { headers: noResponseToastHeaders }
      );
   }

   public searchTranslatedCountries(
      searchTerm?: string
   ): Observable<Array<CountryModel>> {
      let uri = `${this.baseUri}/${this.endpoint}/countries/search?language=${this.appSettings.selectedLanguage}`;
      if (searchTerm) {
         uri += `&searchTerm=${searchTerm}`;
      }

      return this.httpClient.get<Array<CountryModel>>(uri, {
         headers: noResponseToastHeaders
      });
   }
}
